import { axiosClient, USER_VARIABLE } from '@nx-frontend/shared/api';
import { SetShareSettingsOpenedPayload, UserVar } from '@nx-frontend/shared/types';

export const setShareSettingsOpened = async ({
  userId,
  value,
}: SetShareSettingsOpenedPayload): Promise<UserVar | null> => {
  const response = await axiosClient.post(
    `/v2/api/users/vars/${USER_VARIABLE.SHARE_SETTINGS_OPENED}`,
    {
      value,
    },
    { userId }
  );
  return response.data as UserVar;
};
